export default class OeeCalculator {
    
    constructor(oeeChart) {

        this.registerEvents();

        this.oeeChart = oeeChart;

        this.v = {};

    }
    

    /*--- toggle calculator ------------------------------------------------------*/


    toggleCalculator(el) {

        document.querySelector('.active-calculator').classList.remove('active-calculator');
        document.getElementById(el.dataset.tool).classList.add('active-calculator');

    }

    toggleCalculatorSwitcher(el) {

        if(!el.classList.contains('active'))
        {
            document.querySelector('.tool-selector-option.active').classList.remove('active');
            el.classList.add('active');
        }

    }


    /*--- get form values ------------------------------------------------------*/


    getFormValues() {

        return {

            'plannedRuntime': +this.getDataPeriodDuration(document.getElementById('planned-runtime-measure').value, document.getElementById('planned-runtime').value),
            'downtime': +this.getDataPeriodDuration(document.getElementById('downtime-measure').value, document.getElementById('downtime').value),
            'targetOutput': document.getElementById('target-output').value,
            'potentialOutput': document.getElementById('potential-output').value,
            'actualOutput': document.getElementById('actual-output').value,
            'waste': document.getElementById('waste').value,

       };
 
    }

    
    /*--- get data period duration ------------------------------------------------------*/


    getDataPeriodDuration(measurement, duration) {

        switch(measurement)
        {
            case 'days':
                return duration * 24 * 60;
                break;

            case 'hours':
                return duration * 60;
                break;

            case 'minutes':
            default:
                return +duration;
                break;
        }

    }


    /*--- calculate potential target ------------------------------------------------------*/


    updatePotentialTarget(v) {
        
        if(v.targetOutput >= 0 && v.plannedRuntime > 0)
        {
            const ppm = v.targetOutput / v.plannedRuntime;
            const uptime = v.plannedRuntime - v.downtime;
    
            const potentialTarget = uptime * ppm;
    
            document.querySelector('#potential-output').value = +potentialTarget.toFixed(1);
        }

    }


    /*--- calculate oee metrics ------------------------------------------------------*/


    calcAvailability(v) {

        let uptime = v.plannedRuntime - v.downtime;
        
        return uptime > 0
            ? uptime / v.plannedRuntime * 100
            : 0;

    }

    calcPerformance(v) {

        return v.actualOutput / v.potentialOutput * 100;

    }

    calcQuality(v) {

        let good = v.actualOutput - v.waste;

        if(good <= 0) return 0;

        return good / v.actualOutput * 100;

    }

    calcOee(a, p, q) {

        a = a / 100;
        p = p / 100;
        q = q / 100;
        
        return (a * p * q) * 100;

    }


    /*--- update oee ------------------------------------------------------*/


    updateOee(oee) {

        // calculate oee
        if(oee >= 0)
        {
            // update chart label
            document.querySelector('#oee-chart-figure span:first-of-type').innerHTML = +oee.toFixed(1);
            
            // update chart (uses min/max to ensure donut max's at 100% fill)
            this.oeeChart.data.datasets[0].data = [
                Math.min(oee, 100),
                Math.max(100 - oee, 0)
            ];
            this.oeeChart.update();
        }

    }


    /*--- update projection ------------------------------------------------------*/


    updateProjection(v, oeeIncrease, timePeriod) {
        
        const parts100 = v.totalHours * v.partsPerHour;
        const profit100 = parts100 * v.profitPerPart;
        const parts1 = parts100 / 100;
        const profit1 = profit100 / 100;

        document.querySelector('[data-100-parts]').innerHTML = parts100.toLocaleString();
        document.querySelector('[data-100-profit]').innerHTML = profit100.toLocaleString();
        document.querySelector('[data-1-parts]').innerHTML = parts1.toLocaleString();
        document.querySelector('[data-1-profit]').innerHTML = profit1.toLocaleString();
        
        document.getElementById('daily-projection').value = (profit1 * oeeIncrease).toLocaleString();
        document.getElementById('future-projection').value = ((profit1 * oeeIncrease) * timePeriod).toLocaleString();

    }


    /*--- events ------------------------------------------------------*/


    registerEvents() {

        // event: switch calculator
        document.querySelectorAll('.tool-selector-option').forEach(el => {

            el.addEventListener('click', e => {
                
                this.toggleCalculator(e.currentTarget);
                this.toggleCalculatorSwitcher(e.currentTarget);
                
            });

        });
                
        // event: process form
        ['change', 'keyup'].forEach(eventType => {

            document.getElementById('oee-data-form').addEventListener(eventType, e => {

                e.preventDefault();
                
                // get form values
                const v = this.getFormValues();
                
                // update potential target
                this.updatePotentialTarget(v);

                // calculate oee metrics
                const a = this.calcAvailability(v);
                const p = this.calcPerformance(v);
                const q = this.calcQuality(v);
                const oee = this.calcOee(a, p, q);
                
                // update oee
                this.updateOee(oee);
    
            });

        });
                
    }

}
